import React, { useEffect, useState } from 'react';
import RadioButtons from '../../common/RadioButtons/RadioButtons';
import { AUDIO_INPUT_DEVICE_KEY } from '../../../constants/appRuntime';
import { useNavigate } from 'react-router-dom';
import { TRAINER_PAGE } from '../../../utils/routes';
import { useAppDispatch } from '../../../store/hooks';
import { audioDeviceReload } from '../../../store/actions/trainer';

const DEFAULT_DEVICE_NAME = 'default';

export interface AudioDevice {
    label: string;
    name: string;
    isMicrophone: boolean;
    isSpeaker: boolean;
}

interface LocalizationLike {
    getText: (key: string) => string;
}

const normilizeName = (name: string) => {
    if (name.indexOf('>') !== -1) {
        return name.substring(name.indexOf('>') + 1).trim();
    }

    return name;
};

export function AudioDeviceSelector({ localization }: { localization: LocalizationLike }) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [devices, setDevices] = useState<AudioDevice[]>([]);
    const [selectedDevice, setSelectedDevice] = useState(localStorage.getItem(AUDIO_INPUT_DEVICE_KEY));

    useEffect(() => {
        const getDeviceList = window.electronAPI?.getDeviceList;
        if (getDeviceList) {
            getDeviceList((list: AudioDevice[]) =>
                setDevices(
                    list
                        .filter((d: AudioDevice) => d.name.toLowerCase().indexOf('loopback') === -1)
                        .map(device => ({ ...device, label: normilizeName(device.name) }))
                )
            );
        }
    }, []);

    const deviceNames = [
        {
            value: localization.getText('settings.inputDevice.defaultDevice'),
            key: DEFAULT_DEVICE_NAME
        }
    ].concat(
        devices
            .filter(device => device.isMicrophone)
            .map(device => {
                return {
                    value: device.label,
                    key: device.name
                };
            })
    );

    return (
        <RadioButtons
            selectorValues={deviceNames}
            selected={selectedDevice || DEFAULT_DEVICE_NAME}
            onChange={(selection: string) => {
                setSelectedDevice(selection);
                localStorage.setItem(AUDIO_INPUT_DEVICE_KEY, selection === 'default' ? '' : selection);

                navigate(TRAINER_PAGE);

                dispatch(audioDeviceReload());
            }}
        />
    );
}
